import { getNaccIdFromDetails } from '../../../../../../helpers/naccAlias';
import CaseBuilderPanel from '../../../CaseBuilderPanel';
import styles from '../../CaseBuilderEnhanced.module.css';

export default function ClinicalStep({ doc, schemas, workspace, protocolId }) {
    const naccId = getNaccIdFromDetails(doc?.details);

    return (
        <div className={styles.stepContent}>
            {naccId && (
                <div className={`${styles.banner} ${styles.bannerInfo}`}>
                    NACC ID {naccId} — clinical fields may have been imported from NACC.
                </div>
            )}

            <div className={styles.panel}>
                <h3 className={styles.panelTitle}>Clinical metadata</h3>
                <p className={styles.pageSubtitle}>
                    Select a schema version and save clinical details for this case.
                </p>
                <CaseBuilderPanel
                    item={doc}
                    onSave={workspace.onSave}
                    schemas={schemas}
                    protocolId={protocolId}
                />
            </div>

            <div className={styles.panel} style={{ marginTop: '1rem' }}>
                <h3 className={styles.panelTitle}>NACC alias</h3>
                <div className={styles.formRow}>
                    <label className={styles.formLabel} htmlFor="enhanced-nacc-id">NACC ID</label>
                    <input
                        id="enhanced-nacc-id"
                        type="text"
                        className={styles.input}
                        value={workspace.naccIdDraft}
                        onChange={(e) => workspace.setNaccIdDraft(e.target.value)}
                        placeholder="e.g. NACC876161"
                    />
                </div>
                <div className={styles.toolbar}>
                    <button
                        type="button"
                        className={styles.buttonPrimary}
                        disabled={workspace.naccUpdatePending || workspace.naccClinicalPending || !workspace.naccChanged}
                        onClick={() => workspace.handleUpdateNaccId()}
                    >
                        {workspace.naccUpdatePending ? 'Saving…' : 'Save NACC ID'}
                    </button>
                    <button
                        type="button"
                        className={styles.buttonSecondary}
                        disabled={workspace.naccClinicalPending || !(workspace.naccIdDraft || workspace.savedNaccId)}
                        onClick={() => workspace.handlePullNaccClinical()}
                    >
                        {workspace.naccClinicalPending ? 'Pulling…' : 'Pull clinical from NACC'}
                    </button>
                </div>
                {workspace.naccClinicalStatus && (
                    <p className={workspace.naccClinicalStatus.ok ? styles.statusOk : styles.statusError}>
                        {workspace.naccClinicalStatus.message}
                    </p>
                )}
            </div>
        </div>
    );
}
